import { render, staticRenderFns } from "./giftCardList.vue?vue&type=template&id=9675fda6&"
import script from "./giftCardList.vue?vue&type=script&lang=js&"
export * from "./giftCardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports